<template lang="pug">
.confirm-card
  q-card.no-shadow
    q-card-section.confirm-card-title
      .confirm-card-subtext(v-if="subtext") {{ subtext }}
      span {{ message }}

    q-card-actions.button-group.row.justify-center
      q-btn.modal-form-cancel(flat, no-caps, :label="cancelLabel", @click="confirm(false)")
      q-btn.modal-form-submit(flat, no-caps, :label="confirmLabel", @click="confirm(true)")
</template>

<script setup>
import { computed } from "vue";
import { confirmModalLocales } from "@/services/useLocales";

const props = defineProps({
  /**
   * Данные модального окна подтверждения. Ключ message содержит основной текст.
   * Ключи subtext, cancelLabel и confirmLabel необязательные.
   * Пример: {
   *  message: "Вы подтверждаете удаление мероприятий?",
   *  subtext: "Вы удалили мероприятие \"Техническое обслуживание\".",
   *  cancelLabel: "Нет",
   *  confirmLabel: "Да"
   * }
   */
  parentData: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits([
  /** Эмит результата подтверждения. Передает true при подтверждении и false при отмене. */
  "confirm",
]);

const message = computed(() => props.parentData.message || "");
const subtext = computed(() => props.parentData.subtext || "");
const cancelLabel = computed(() => props.parentData.cancelLabel || confirmModalLocales.value.cancel);
const confirmLabel = computed(() => props.parentData.confirmLabel || confirmModalLocales.value.submit);

const confirm = value => {
  emit("confirm", value);
};
</script>

<style lang="scss">
@import "../../../assets/styles/forms/confirm-modal";
</style>
